import { combineReducers } from "redux";
import visitCategories from "./internalVisitCategoriesReducer";
import branches from "src/internal/reducers/internalBranchesReducer";
import branchHours from "src/external/reducers/branchHoursReducer";
import appSettings from "./internalAppSettingsReducer";
import defaultCustomerPrefs from "./internalCustomerPrefsReducer";
import serviceRepresentatives from "./serviceRepresentativesReducer";
import errorMessage from "../../common/reducers/errorMessageReducer";
import authentication from "./authReducer";
import dnaRepresentatives from "./dnaRepresentativesReducer";
import branchAdmins from "./branchAdminsReducer";
import { systemAdminsReducer as systemAdmins } from "./systemAdminsReducer";
import systemTimeZones from "./timeZonesReducer";
import adminAppSettings from "./adminAppSettingsReducer";
import volumeReport from "./volumeReportReducer";
import serviceLocationReport from "./serviceLocationReportReducer";
import appointmentsListReport from "./appointmentsListReportReducer";
import reminders from "./internalRemindersReducer";
import reportingSyncUpdatedTime from "./reportingSyncUpdatedTimeReducer";
import videos from "../../common/reducers/videosReducer";
import resourceByServiceReport from "./resourceByServiceReportReducer";
import callDownListReport from "./callDownListReportReducer";
import marketingLinks from "./internalMarketingLinksReducer";
import serviceLevelsReport from "./serviceLevelsReportReducer";
import surveyFeedbackDetailsReport from "./surveyFeedbackDetailsReportReducer";
import surveyFeedbackSummaryReport from "./surveyFeedbackSummaryReportReducer";
import surveyDto from "./surveyReducer";
import appContext from "./appContextReducer";
import virtualMeetingConnection from "../../internal/reducers/virtualMeetingConnectionTestReducer";
import marketingLinkSummaryReport from "./marketingLinkSummaryReportReducer";
import failedAppointmentAttemptsReport from "./failedAppointmentAttemptsReportReducer";
import allAdminCategories from "./adminCategoriesReducer";

/**
 * Consider using immer to keep our reducers clean and simple
 * https://github.com/mweststrate/immer#reducer-example
 */

export default combineReducers({
  adminAppSettings,
  allAdminCategories,
  virtualMeetingConnection,
  appContext,
  appointmentsListReport,
  appSettings,
  authentication,
  branchAdmins,
  systemAdmins,
  branches,
  branchHours,
  callDownListReport,
  defaultCustomerPrefs,
  dnaRepresentatives,
  errorMessage,
  marketingLinks,
  marketingLinkSummaryReport,
  reminders,
  resourceByServiceReport,
  reportingSyncUpdatedTime,
  serviceLevelsReport,
  serviceLocationReport,
  serviceRepresentatives,
  surveyDto,
  surveyFeedbackDetailsReport,
  surveyFeedbackSummaryReport,
  systemTimeZones,
  videos,
  visitCategories,
  volumeReport,
  failedAppointmentAttemptsReport
});
